module.exports = __webpack_public_path__ + "static/media/drum.cc33cf38.png";